import Vue from 'vue'
import EnquiryDirect from '../../views/enquiry/EnquiryDirect'
import EnquiryDirectEcoventure from '../../views/enquiry/EnquiryDirectEcoventure'
import Enquiry from '../../views/enquiry/Enquiry'
import BecomePartner from '../../views/enquiry/BecomePartner'
import Newsletter from '../../views/enquiry/Newsletter'
import GeneralEnquiry from '../../views/enquiry/GeneralEnquiry'
import WorkAtZublu from '../../views/enquiry/WorkAtZublu'
import CharterYacht from '../../views/enquiry/CharterYacht'
import once from "lodash/once";
import CurrencyContext from '../../components/core/CurrencyContext'

window.fetchSupplierInfo = once((supplierId) => {
  return new Promise((resolve, reject) => {
    $.get(`${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/supplier_info?supplier_id=${supplierId}`)
      .done(res => {
        if (res === 'No Supplier Found') {
          reject()
        }
        else {
          resolve(res)
        }
      })
      .fail(reject)
  })
})

Vue.component('enquiry', Enquiry)
Vue.component('enquiry-direct', EnquiryDirect)
Vue.component('enquiry-direct-ecoventure', EnquiryDirectEcoventure)
Vue.component('become-partner', BecomePartner)
Vue.component('general-enquiry', GeneralEnquiry)
Vue.component('work-at-zublu', WorkAtZublu)
Vue.component('charter-yacht', CharterYacht)
Vue.component('newsletter', Newsletter)
Vue.component('currency-context', CurrencyContext)

const apps = document.querySelectorAll('.vue-app')

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
